<template>
    <div class="background-grid-blue">
        <slot />
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.background-grid-blue {
    width: 100%;
    height: 100%;
    background-image: url("/images/promo/connect-features/background-grid-blue.svg");
    background-size: 100% auto, cover;
    background-repeat: no-repeat, no-repeat;
    background-position: top, top;

    @media (max-width: 700px) {
      background-size: 200% auto, cover;
    }

    @media (max-width: 500px) {
      background-size: 300% auto, cover;
    }
}
</style>
